import { useQuery } from "@tanstack/react-query";
import useRetailShop from "../../hooks/useRetailShop";
import { useRouter } from "next/router";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { formatCurrency } from "../../core/currency.core";
import giftCardCore from "../../core/giftCard.core";
import { CustomerItem } from "../../types/customer";

export default function CustomerGiftCards({ user }: { user: CustomerItem }) {
  return (
    <section className="space-y-10">
      <RecycleInventoryList userId={user.id} />
    </section>
  );
}

const RecycleInventoryList = ({ userId }: { userId: string }) => {
  const { isReady } = useRouter();
  const pos = useRetailShop();

  const {
    data: giftCards,
    isError,
    isPending,
    failureReason,
  } = useQuery({
    queryKey: ["user-gift-cards"],
    queryFn: () => giftCardCore.listGiftCard({ userId }),
    enabled: isReady,
  });

  if (isError) return <ErrorCenterIcon reason={failureReason} />;
  if (isPending) return <LoadingOvalCenterIcon />;
  if (!pos) return null;

  return (
    <section className="space-y-4 overflow-y-scroll">
      {giftCards.map((i) => (
        <div key={i.id} className="grid grid-cols-[2fr_2fr_1fr_1fr] border-b-2 border-her-darkgray dark:border-white">
          <p className="text-left">{i.code}</p>
          <p className="truncate text-left">{i.name}</p>
          <p className="text-right">{formatCurrency(i.value, pos?.defaultCurrency)}</p>
          <p className="text-right">{i.status}</p>
        </div>
      ))}
    </section>
  );
};
